import { render, staticRenderFns } from "./listManage.vue?vue&type=template&id=240d6cfd&scoped=true"
import script from "./listManage.vue?vue&type=script&lang=js"
export * from "./listManage.vue?vue&type=script&lang=js"
import style0 from "./listManage.vue?vue&type=style&index=0&id=240d6cfd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d6cfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240d6cfd')) {
      api.createRecord('240d6cfd', component.options)
    } else {
      api.reload('240d6cfd', component.options)
    }
    module.hot.accept("./listManage.vue?vue&type=template&id=240d6cfd&scoped=true", function () {
      api.rerender('240d6cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/risk/listManage.vue"
export default component.exports